import axios from 'axios';
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil';
import {DESATIVAR_USUARIO_EMPRESA} from '../types';
import {URL} from '../../util/ambienteActions';

export default function desativarUsuarioEmpresa (idUsuario, idEmpresa) {
    const url = `${URL}/usuarios/${idUsuario}/empresa/${idEmpresa}/desativar`;
    return dispatch => axios.post(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
          type: DESATIVAR_USUARIO_EMPRESA,
          payload: response
  
        })
    );
}
